import { render, staticRenderFns } from "./DiscountManual.vue?vue&type=template&id=0675d060"
import script from "./DiscountManual.vue?vue&type=script&lang=js"
export * from "./DiscountManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports